module.exports = __webpack_public_path__ + "img/ambalal_shares_logo.66055dc7.jpg";